import { takeEvery } from 'redux-saga/effects';

import * as actions from 'store/modules/bookingReviews';

import { sendReview } from './utils';

export default function* listenSendReview() {
  yield takeEvery(actions.sendReview.type, sendReview);
}
